import React, { useEffect, useState } from "react";
import ComponentTitle from "../../layout/ComponentTitle";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ComponentModaleNotifier from "../../layout/ComponentModaleNotifier";
import { apiGetNotifications } from "../../../api/ApiNotification";
import { MdAddCircleOutline } from "react-icons/md";
import { Badge, CardGroup } from "react-bootstrap";
import { toDateParseFR } from "../../../utils/datesHeures";

const BlocEpingleNotif = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [showModalNotif, setShowModalNotif] = useState(false);
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);
  const [notifications, setNotifications] = useState([]);

  const isAdminEasygouv = () => {
    // si je suis souscripteur
    if (ReduxUserEmail === ReduxInstance.souscripteur) return true;
    // si je suis dans le tableau des adminProcessAccess
    if (ReduxInstance.adminProcessAccess.indexOf(ReduxUserEmail) > -1) return true;

    return false;
  };

  const recupNotifications = async () => {
    setLoading(true);
    const res = await apiGetNotifications(ReduxInstance._id, "sort=datePeremption");
    if (res) {
      let today = new Date();
      //   today.setDate(today.getDate() + 2);
      let todayFormat =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1 < 10 ? "0" : "") +
        (today.getMonth() + 1) +
        "-" +
        (today.getDate() < 10 ? "0" : "") +
        today.getDate();
      //   console.log(todayFormat);
      const notificationsValides = res.data.filter(
        (notification) => notification.datePeremption >= todayFormat
      );
      setNotifications(notificationsValides);
      setLoading(false);
    } else {
      console.log("Error");
    }
  };

  useEffect(() => {
    recupNotifications();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {(isAdminEasygouv() || notifications.length > 0) && (
        <div className="mt-3 blocNotification hackHomeEthicsTransparent">
          <div className="justify-content-center fw-bold d-flex mb-3 align-items-center">
            {t("public.pageHome.titleBlocNotifications")}
            {isAdminEasygouv() && (
              <>
                <ComponentModaleNotifier
                  showModalNotif={showModalNotif}
                  setShowModalNotif={setShowModalNotif}
                  handleRecupDatas={recupNotifications}
                />
                <div role="button" onClick={(e) => setShowModalNotif(true)} className="ms-2">
                  <MdAddCircleOutline size="1.5em" />
                </div>
              </>
            )}
          </div>
          {notifications.map((notification, index) => (
            <div className="mb-3" key={notification._id}>
              <div className="titleNotification">
                <span>
                  {notification.importance != "normal" && (
                    <span className={"importanceNotification_" + notification.importance}>⚠ </span>
                  )}
                  {notification.title}
                </span>
                <span className="dateNotification">{toDateParseFR(notification.createdAt)}</span>
              </div>
              {notification.body}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default BlocEpingleNotif;
